import { IdType, SharingData } from './schema/SharingData';
import { SharingInfo } from './schema/SharingInfo';
import { isGuestUrlPermissionLevel } from './selectors/isGuestUrlPermissionLevel';
import { isValidGetSharingInfoResponse } from './selectors/isValidGetSharingInfoResponse';
import { isExpired } from './selectors/sharingIssueDetectors/isExpired';
import { isExpiring } from './selectors/sharingIssueDetectors/isExpiring';
import { SharingTipAction } from './types/SharingTipAction';
import { getSharingTipIdsList, SharingTipId } from './types/sharingTipId';
import { SharingTipInfo } from './types/SharingTipInfo';
import { SharingTipRecipientInfo } from './types/SharingTipRecipientInfo';
import { getInfoBarCreator } from './utils/getInfoBarCreator';
import { getSharingIssuesForSharingData } from './utils/getSharingIssuesForSharingData';
import { LazyImport, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "SharingData", webpackPrefetch: true */ './lazyIndex')
);

// Delay loaded services
export const lazyGetSharingInformation = new LazyImport(lazyModule, m => m.getSharingInformation);

// export public actions
export { refreshExpirationDate } from './actions/publicActions';

export { RecipientPermissionInfo, GetPermissionInfoStatus } from './schema/RecipientPermissionInfo';
export {
    getSharingIssuesForSharingData,
    IdType,
    isExpired,
    isExpiring,
    SharingTipId,
    SharingData,
    SharingInfo,
    SharingTipAction,
    SharingTipInfo,
    SharingTipRecipientInfo,
    getSharingTipIdsList,
    getInfoBarCreator,
    isGuestUrlPermissionLevel,
    isValidGetSharingInfoResponse,
};
